import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeDir: localStorage.getItem('activeDir') || 'ltr',
  activeMode: localStorage.getItem('activeMode') || 'light', // This can be light or dark
  activeTheme: localStorage.getItem('activeTheme') || 'LMS_THEME', // BLUE_THEME, GREEN_THEME, RED_THEME, BLACK_THEME, PURPLE_THEME, INDIGO_THEME
  SidebarWidth: 270,
  MiniSidebarWidth: 87,
  TopbarHeight: 70,
  isLayout: localStorage.getItem('isLayout') || 'boxed', // This can be full or boxed
  isCollapse: false, // to make sidebar Mini by default
  isSidebarHover: false,
  isMobileSidebar: false,
  isHorizontal: false,
  isLanguage: localStorage.getItem('isLanguage') || 'en',
  isCardShadow: JSON.parse(localStorage.getItem('isCardShadow')) ?? true,
  borderRadius: Number(localStorage.getItem('borderRadius')) || 7,
};

export const CustomizerSlice = createSlice({
  name: 'customizer',
  initialState,
  reducers: {
    setTheme: (state, action) => {
      state.activeTheme = action.payload;
      localStorage.setItem('activeTheme', action.payload);
    },
    setDarkMode: (state, action) => {
      state.activeMode = action.payload;
      localStorage.setItem('activeMode', action.payload);
    },
    setDir: (state, action) => {
      state.activeDir = action.payload;
      localStorage.setItem('activeDir', action.payload);
    },
    setLanguage: (state, action) => {
      state.isLanguage = action.payload;
      localStorage.setItem('isLanguage', action.payload);
    },
    setCardShadow: (state, action) => {
      state.isCardShadow = action.payload;
      localStorage.setItem('isCardShadow', action.payload);
    },
    toggleSidebar: (state) => {
      state.isCollapse = !state.isCollapse;
    },
    hoverSidebar: (state, action) => {
      state.isSidebarHover = action.payload;
    },
    toggleMobileSidebar: (state) => {
      state.isMobileSidebar = !state.isMobileSidebar;
    },
    toggleLayout: (state, action) => {
      state.isLayout = action.payload;
      localStorage.setItem('isLayout', action.payload);
    },
    toggleHorizontal: (state, action) => {
      state.isHorizontal = action.payload;
    },
    setBorderRadius: (state, action) => {
      state.borderRadius = action.payload;
      localStorage.setItem('borderRadius', action.payload);
    },
  },
});


export const {
  setTheme,
  setDarkMode,
  setDir,
  toggleSidebar,
  hoverSidebar,
  toggleMobileSidebar,
  toggleLayout,
  setBorderRadius,
  toggleHorizontal,
  setLanguage,
  setCardShadow,
} = CustomizerSlice.actions;

export default CustomizerSlice.reducer;
